import { GridLegacy as Grid } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import { keyStrengthsData } from './KeyStrengths.data';
import type { HeroProps } from './KeyStrengthsServices.types';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';

export const KeyStrengths = ({ ...props }: HeroProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {keyStrengthsData.mainText}
          </StyledFirstTitle>
          <StyledSecondTitle variant="regular_500">
            {keyStrengthsData.description}
          </StyledSecondTitle>
        </StyledTwoTitles>
        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {keyStrengthsData.services.map((strength, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon
                      src={strength.img}
                      alt={strength.title}
                    />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {strength.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {strength.description}
                </StyledServiceDescription>
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
